// @generated by scripts/metadata/generate.mjs — do not edit.
// Regenerate with `yarn generate:metadata`.

// backend/app/shared_metadata/metric_types.csv
export interface MetricTypeRow {
  metric_type: string | boolean | null;
  readable_name: string | boolean | null;
  description: string | boolean | null;
  metric_group_type: string | boolean | null;
  cost_type: string | boolean | null;
  comment: string | boolean | null;
  unit: string | boolean | null;
  include_in_compare: string | boolean | null;
  live_bound: string | boolean | null;
  table_grouping: string | boolean | null;
}

export const METRIC_TYPES = [
  "avg",
  "cnt",
  "cnt_distinct",
  "cnt_values",
  "cpu_time",
  "definity_driver_overhead",
  "definity_executors_overhead",
  "duration",
  "freshness",
  "live_max_time_delta",
  "max",
  "max_time",
  "max_time_delta",
  "memory_time",
  "meta_cnt",
  "meta_filesSize",
  "meta_metadataTime",
  "meta_numFiles",
  "meta_numOutputBytes",
  "meta_numOutputRows",
  "meta_numPartitions",
  "meta_numParts",
  "meta_pruningTime",
  "meta_scanTime",
  "meta_staticFilesNum",
  "meta_staticFilesSize",
  "min",
  "nan_cnt",
  "null_pct",
  "num_changed_params",
  "num_executors",
  "num_jobs",
  "num_params",
  "num_schema_changes",
  "num_spark_jobs",
  "num_spark_stages",
  "num_spark_tasks",
  "num_stages",
  "num_tasks",
  "num_tfs",
  "pct_distinct",
  "pct_unique",
  "process_time",
  "schema_cnt",
  "sla",
  "stddev",
  "used_cpu_time",
  "used_vcore_time",
  "vcore_time",
  "vcore_utilization",
  "driver_memory",
  "driver_heap_memory",
  "driver_off_heap_memory",
  "driver_max_used_memory",
  "driver_max_heap_used_memory",
  "driver_max_off_heap_used_memory",
  "driver_max_memory_utilization",
  "driver_max_heap_memory_utilization",
  "driver_max_off_heap_memory_utilization",
  "executor_memory",
  "executor_heap_memory",
  "executor_off_heap_memory",
  "executor_max_used_memory",
  "executor_max_heap_used_memory",
  "executor_max_off_heap_used_memory",
  "executor_max_memory_utilization",
  "executor_max_heap_memory_utilization",
  "executor_max_off_heap_memory_utilization",
  "input_records_read",
  "output_records_written",
  "shuffle_records_read",
  "shuffle_records_written",
  "input_bytes_read",
  "output_bytes_written",
  "shuffle_bytes_read",
  "shuffle_bytes_written",
  "tasks_result_size_bytes",
  "broadcasts_count",
  "broadcasts_failures",
  "broadcasts_numOutputRows",
  "broadcasts_collectTime",
  "broadcasts_buildTime",
  "broadcasts_broadcastTime",
  "broadcasts_dataSize",
  "memory_bytes_spilled",
  "disk_bytes_spilled",
  "skew_score",
  "executors_vcore_time",
  "executors_used_vcore_time",
  "executors_run_time",
  "tasks_duration",
  "executors_used_vcore_time_of_retried_tasks",
  "executors_used_cpu_time",
  "executors_cpu_time",
  "executors_orphaned_cpu_time",
  "executors_occupied_cpu_time",
  "executors_machine_cpu_time",
  "executors_measured_core_time",
  "driver_cpu_time",
  "driver_used_cpu_time",
  "executors_jvm_gc_time",
  "executors_shuffle_read_time",
  "executors_shuffle_write_time",
  "executors_idle_time",
  "num_spark_tasks_retries",
  "num_spark_tasks_failures",
  "num_spark_stages_retries",
  "num_spark_stages_failures",
  "num_lost_executors",
  "executors_killed_oom",
  "executors_killed_preempted",
  "executors_killed_heartbeat_lost",
  "executors_killed_error",
  "executors_killed_unknown",
  "executors_killed_decommissioned",
  "executors_spot",
  "executors_on_demand",
  "executors_spot_cpu_time",
  "executors_on_demand_cpu_time",
  "count_task_failures",
  "count_task_retries",
  "task_idle_time",
  "approx_lingering_vcores_time_pct",
  "driver_cpu_utilization",
  "driver_jvm_gc_time",
  "driver_jvm_gc_time_pct",
  "cached_data_max_memory_size",
  "cached_data_max_disk_size",
  "driver_cores",
  "executor_cores",
  "s3_list_objects_requests",
  "s3_put_object_requests",
  "s3_get_object_requests",
  "s3_head_object_requests",
  "fs_open_requests",
  "fs_list_requests",
  "executors_python_used_cpu_time",
  "executors_java_used_cpu_time",
  "executors_other_used_cpu_time",
  "executor_managed_storage_memory_on_heap_max_used",
  "executor_managed_execution_memory_on_heap_max_used",
  "executor_managed_on_heap_memory_max_used",
  "executor_managed_storage_memory_off_heap_max_used",
  "executor_managed_off_heap_memory_max_used",
  "executor_managed_execution_memory_off_heap_max_used",
  "batch_duration",
  "batch_count",
  "trigger_count",
  "global_watermark_gap",
  "state_total_rows",
  "state_updated_rows",
  "state_memory_used_bytes",
  "rows_dropped_by_watermark",
  "input_rows_per_sec",
  "processed_rows_per_sec",
  "num_input_rows",
  "num_output_rows",
  "bytes_billed",
  "slot_ms",
  "queue_ms",
  "credits",
  "num_tests_passed",
  "num_tests_failed",
  "num_tests_warned",
  "num_tests_errored",
  "num_tests_skipped",
  "tests_pass_ratio",
  "num_tfs_failures",
  "hosts_max_disk_used",
  "hosts_total_disk_used_max",
  "hosts_max_disk_utilization",
  "executors_max_disk_used",
  "executors_total_disk_used_max",
  "executors_max_disk_utilization",
  "executors_total_disk_read_bytes_per_sec_max",
  "executors_total_disk_write_bytes_per_sec_max",
  "executors_total_network_read_bytes_per_sec_max",
  "executors_total_network_write_bytes_per_sec_max",
  "driver_disk_read_bytes_per_sec_max",
  "driver_disk_write_bytes_per_sec_max",
  "driver_network_read_bytes_per_sec_max",
  "driver_network_write_bytes_per_sec_max",
  "shuffle_remote_bytes_read_to_disk",
  "scheduler_delay",
  "executors_deserialize_time",
  "executors_serialize_time",
  "getting_result_time",
  "shuffle_local_bytes_read",
  "shuffle_remote_bytes_read",
  "shuffle_local_blocks_fetched",
  "shuffle_remote_blocks_fetched",
  "shuffle_remote_reqs_time",
  "shuffle_push_remote_merged_bytes_read",
  "shuffle_push_local_merged_bytes_read",
  "shuffle_push_remote_merged_blocks_fetched",
  "shuffle_push_local_merged_blocks_fetched",
  "shuffle_push_remote_merged_chunks_fetched",
  "shuffle_push_local_merged_chunks_fetched",
  "shuffle_push_remote_merged_reqs_time",
  "shuffle_push_corrupt_merged_block_chunks",
  "shuffle_push_merged_fetch_fallback_count",
  "broadcasts_numHashKeys",
  "broadcasts_numHashValues",
  "listener_bus.queue.appStatus.numDroppedEvents",
  "listener_bus.queue.eventLog.numDroppedEvents",
  "listener_bus.queue.executorManagement.numDroppedEvents",
  "listener_bus.queue.shared.numDroppedEvents",
  "meta_numSourceRows",
  "meta_numUpdatedRows",
  "meta_numDeletedRows",
  "meta_numCopiedRows",
  "meta_numRowsRemoved",
  "meta_numTargetRowsInserted",
  "meta_numTargetRowsUpdated",
  "meta_numTargetRowsDeleted",
  "meta_numTargetRowsCopied",
  "meta_numTargetRowsRemoved",
  "meta_numTargetRowsMatchedUpdated",
  "meta_numTargetRowsMatchedDeleted",
  "meta_numTargetRowsNotMatchedBySourceUpdated",
  "meta_numTargetRowsNotMatchedBySourceDeleted",
  "dbx_list_cost",
] as const;
export type MetricTypeName = (typeof METRIC_TYPES)[number];

export const METRIC_TYPE_METADATA: Record<MetricTypeName, MetricTypeRow> = {
  avg: {
    metric_type: "avg",
    readable_name: "Average",
    description: "Average value for numeric column",
    metric_group_type: "distribution",
    cost_type: "one-pass",
    comment: "",
    unit: "",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Min, Max, AVG, Deviation",
  },
  cnt: {
    metric_type: "cnt",
    readable_name: "Query Row Count",
    description:
      "Row count for this dataset - runs a dedicated query on relevant partitions",
    metric_group_type: "volume",
    cost_type: "one-pass",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  cnt_distinct: {
    metric_type: "cnt_distinct",
    readable_name: "Distinct Count",
    description: "Number of distinct values in column",
    metric_group_type: "distribution",
    cost_type: "query",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  cnt_values: {
    metric_type: "cnt_values",
    readable_name: "Value Histogram",
    description: "Low cardinality field histogram of values",
    metric_group_type: "distribution",
    cost_type: "one-pass",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  cpu_time: {
    metric_type: "cpu_time",
    readable_name: "CPU Time",
    description: "Total vcore time allocated for this asset execution",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "moved to vcore_time",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Total resources",
  },
  definity_driver_overhead: {
    metric_type: "definity_driver_overhead",
    readable_name: "Definity Driver Time",
    description: "Time overhead in the driver spent for Definity operations",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "definity",
  },
  definity_executors_overhead: {
    metric_type: "definity_executors_overhead",
    readable_name: "Definity Executors Time",
    description: "Time overhead in the executors spent for Definity operations",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "definity",
  },
  duration: {
    metric_type: "duration",
    readable_name: "Execution Time",
    description: "Elapsed execution time (end_time - start_time)",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "Run times",
  },
  freshness: {
    metric_type: "freshness",
    readable_name: "Table Freshness",
    description: "Time elapsed from previous table update",
    metric_group_type: "freshness",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  live_max_time_delta: {
    metric_type: "live_max_time_delta",
    readable_name: "Live Data Freshness",
    description:
      "The difference between current time and the max time watermark of this column (for output datasets)",
    metric_group_type: "freshness",
    cost_type: "one-pass",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  max: {
    metric_type: "max",
    readable_name: "Max Value",
    description: "Maximum value for numeric column",
    metric_group_type: "distribution",
    cost_type: "one-pass",
    comment: "",
    unit: "",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Min, Max, AVG, Deviation",
  },
  max_time: {
    metric_type: "max_time",
    readable_name: "Max Time",
    description: "Watermark value of time column (maximum date value)",
    metric_group_type: "freshness",
    cost_type: "one-pass",
    comment: "",
    unit: "timestamp",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  max_time_delta: {
    metric_type: "max_time_delta",
    readable_name: "Data Freshness",
    description:
      "The difference between reading/execution time and the max time watermark of this column (for input datasets)",
    metric_group_type: "freshness",
    cost_type: "one-pass",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  memory_time: {
    metric_type: "memory_time",
    readable_name: "Total Memory Time",
    description:
      "Total memory size allocated for this task - executors and the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB-seconds",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "Total resources",
  },
  meta_cnt: {
    metric_type: "meta_cnt",
    readable_name: "Row Count",
    description: "Agent-reported number of read/write rows in asset",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  meta_filesSize: {
    metric_type: "meta_filesSize",
    readable_name: "Files Size",
    description:
      "Spark metadata metric - number of read/written files size for this dataset in the transformation",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  meta_metadataTime: {
    metric_type: "meta_metadataTime",
    readable_name: "",
    description: null,
    metric_group_type: null,
    cost_type: "metadata",
    comment: "not interesting",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  meta_numFiles: {
    metric_type: "meta_numFiles",
    readable_name: "Files Count",
    description:
      "Spark metadata metric - number of read/written files for this dataset in the transformation",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "files",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  meta_numOutputBytes: {
    metric_type: "meta_numOutputBytes",
    readable_name: "Output Size",
    description:
      "Spark metadata metric - number of read/written bytes for this dataset in the transformation",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  meta_numOutputRows: {
    metric_type: "meta_numOutputRows",
    readable_name: "Row Count",
    description:
      "Spark metadata metric - number of read/written rows for this dataset in the transformation",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  meta_numPartitions: {
    metric_type: "meta_numPartitions",
    readable_name: "Partition Count",
    description:
      "Spark metadata metric - number of read/written partitions for this dataset in the transformation",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "partitions",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  meta_numParts: {
    metric_type: "meta_numParts",
    readable_name: "Parts Count",
    description:
      "Spark metadata metric - number of read file parts for this dataset in the transformation",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "file-parts",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  meta_pruningTime: {
    metric_type: "meta_pruningTime",
    readable_name: "",
    description: null,
    metric_group_type: null,
    cost_type: "metadata",
    comment: "not interesting",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  meta_scanTime: {
    metric_type: "meta_scanTime",
    readable_name: "",
    description: null,
    metric_group_type: null,
    cost_type: "metadata",
    comment: "not interesting",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  meta_staticFilesNum: {
    metric_type: "meta_staticFilesNum",
    readable_name: "Static Files Count",
    description: null,
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "not sure what is it",
    unit: "files",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  meta_staticFilesSize: {
    metric_type: "meta_staticFilesSize",
    readable_name: "Static Files Size",
    description: null,
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "not sure what is it",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  min: {
    metric_type: "min",
    readable_name: "Min Value",
    description: "Minimum value for numeric column",
    metric_group_type: "distribution",
    cost_type: "one-pass",
    comment: "",
    unit: "",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Min, Max, AVG, Deviation",
  },
  nan_cnt: {
    metric_type: "nan_cnt",
    readable_name: "NaN Count",
    description: "Count of NaN values for numeric column",
    metric_group_type: "distribution",
    cost_type: "one-pass",
    comment: "",
    unit: "",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  null_pct: {
    metric_type: "null_pct",
    readable_name: "Null Percent",
    description: "Column null value percent out of total rows",
    metric_group_type: "distribution",
    cost_type: "one-pass",
    comment: "",
    unit: "percent",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  num_changed_params: {
    metric_type: "num_changed_params",
    readable_name: "Count Param Changes",
    description: "Number of changes in the task params",
    metric_group_type: "environment",
    cost_type: "metadata",
    comment: "no longer written - issue 7257",
    unit: "integer",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  num_executors: {
    metric_type: "num_executors",
    readable_name: "Spark Executors Count",
    description: "Number of Spark executors used in the task",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark executors",
  },
  num_jobs: {
    metric_type: "num_jobs",
    readable_name: "Spark Job Count",
    description: "Number of spark jobs",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_params: {
    metric_type: "num_params",
    readable_name: "Param Count",
    description: "Number of parameters in the task",
    metric_group_type: "environment",
    cost_type: "metadata",
    comment: "no longer written - issue 7257",
    unit: "integer",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  num_schema_changes: {
    metric_type: "num_schema_changes",
    readable_name: "Schema Changes",
    description: "Number of changes in the schema from previous run",
    metric_group_type: "schema",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  num_spark_jobs: {
    metric_type: "num_spark_jobs",
    readable_name: "Spark Job Count",
    description: "Number of spark jobs",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_spark_stages: {
    metric_type: "num_spark_stages",
    readable_name: "Spark Stage Count",
    description: "Number of spark stages",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_spark_tasks: {
    metric_type: "num_spark_tasks",
    readable_name: "Spark Task Count",
    description: "Number of spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_stages: {
    metric_type: "num_stages",
    readable_name: "Spark Stage Count",
    description: "Number of spark stages",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "moved to num_spark_stages",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_tasks: {
    metric_type: "num_tasks",
    readable_name: "Task Count",
    description: "Number of tasks executed in the pipeline",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "moved to num_spark_tasks",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  num_tfs: {
    metric_type: "num_tfs",
    readable_name: "TF Count",
    description: "Number of transformations executed in the task",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  pct_distinct: {
    metric_type: "pct_distinct",
    readable_name: "Distinct Percent",
    description: 'The percent of "Distinct Count"/"Query Row Count"',
    metric_group_type: "distribution",
    cost_type: "query",
    comment: "",
    unit: "percent",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  pct_unique: {
    metric_type: "pct_unique",
    readable_name: "Unique Percent",
    description: 'The percent of "Distinct Count"/count(not null in column)',
    metric_group_type: "distribution",
    cost_type: "query",
    comment: "",
    unit: "percent",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  process_time: {
    metric_type: "process_time",
    readable_name: "Process Time",
    description: "Sum of the tasks execution times",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  schema_cnt: {
    metric_type: "schema_cnt",
    readable_name: "Column Count",
    description: "Number of columns in dataset",
    metric_group_type: "schema",
    cost_type: "metadata",
    comment: "",
    unit: "columns",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  sla: {
    metric_type: "sla",
    readable_name: "SLA Time",
    description: "Time elapsed since last start_time",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Run times",
  },
  stddev: {
    metric_type: "stddev",
    readable_name: "Standard Deviation",
    description: "Standard deviation for numeric column",
    metric_group_type: "distribution",
    cost_type: "one-pass",
    comment: "",
    unit: "",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Min, Max, AVG, Deviation",
  },
  used_cpu_time: {
    metric_type: "used_cpu_time",
    readable_name: "Used CPU Time",
    description: "Actual utilized vCore time in this asset execution",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "moved to used_vcore_time",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore total time",
  },
  used_vcore_time: {
    metric_type: "used_vcore_time",
    readable_name: "Used vCore Time",
    description: "Actual utilized vCore time in this asset execution",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "vCore total time",
  },
  vcore_time: {
    metric_type: "vcore_time",
    readable_name: "Allocated vCore Time",
    description: "Total vCore time allocated for this asset execution",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "vCore total time",
  },
  vcore_utilization: {
    metric_type: "vcore_utilization",
    readable_name: "Utilized vCore Time",
    description: "Percentage of vCore time not in idle",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: false,
    live_bound: "lower_bound",
    table_grouping: "vCore total time",
  },
  driver_memory: {
    metric_type: "driver_memory",
    readable_name: "Driver Memory Allocated",
    description: "The allocated memory for the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_heap_memory: {
    metric_type: "driver_heap_memory",
    readable_name: "Driver On-Heap Memory Allocated",
    description: "The allocated on-heap memory for the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_off_heap_memory: {
    metric_type: "driver_off_heap_memory",
    readable_name: "Driver Off-Heap Memory Allocated",
    description: "The allocated off-heap memory for the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_max_used_memory: {
    metric_type: "driver_max_used_memory",
    readable_name: "Driver Memory Watermark",
    description: "The maximum used memory in the driver (watermark)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_max_heap_used_memory: {
    metric_type: "driver_max_heap_used_memory",
    readable_name: "Driver On-Heap Memory Watermark",
    description: "The maximum used on-heap memory in the driver (watermark)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_max_off_heap_used_memory: {
    metric_type: "driver_max_off_heap_used_memory",
    readable_name: "Driver Off-Heap Memory Watermark",
    description: "The maximum used off-heap memory in the driver (watermark)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_max_memory_utilization: {
    metric_type: "driver_max_memory_utilization",
    readable_name: "Utilized Driver Memory",
    description:
      "Percentage of peak memory used from the total allocated memory in the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_max_heap_memory_utilization: {
    metric_type: "driver_max_heap_memory_utilization",
    readable_name: "Utilized Driver Heap Memory",
    description:
      "Percentage of peak memory used from the total allocated heap memory in the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  driver_max_off_heap_memory_utilization: {
    metric_type: "driver_max_off_heap_memory_utilization",
    readable_name: "Utilized Driver Off-Heap Memory",
    description:
      "Percentage of peak memory used from the total allocated off-heap memory in the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver memory",
  },
  executor_memory: {
    metric_type: "executor_memory",
    readable_name: "Executor Memory Allocated",
    description: "The allocated memory for each executor",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_heap_memory: {
    metric_type: "executor_heap_memory",
    readable_name: "Executor On-Heap Memory Allocated",
    description: "The allocated on-heap memory for each executor",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_off_heap_memory: {
    metric_type: "executor_off_heap_memory",
    readable_name: "Executor Off-Heap Memory Allocated",
    description: "The allocated off-heap memory for each executor",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_max_used_memory: {
    metric_type: "executor_max_used_memory",
    readable_name: "Executor Memory Watermark",
    description: "The maximum used memory across all executors (watermark)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_max_heap_used_memory: {
    metric_type: "executor_max_heap_used_memory",
    readable_name: "Executor On-Heap Memory Watermark",
    description: "The maximum used on-heap memory across all executors (watermark)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_max_off_heap_used_memory: {
    metric_type: "executor_max_off_heap_used_memory",
    readable_name: "Executor Off-Heap Memory Watermark",
    description: "The maximum used off-heap memory in the executors (watermark)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_max_memory_utilization: {
    metric_type: "executor_max_memory_utilization",
    readable_name: "Utilized Executor Memory",
    description:
      "Percentage of peak memory used from the total allocated memory in the executor",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_max_heap_memory_utilization: {
    metric_type: "executor_max_heap_memory_utilization",
    readable_name: "Utilized Executor Heap Memory",
    description:
      "Percentage of peak memory used from the total allocated heap memory in the executor",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  executor_max_off_heap_memory_utilization: {
    metric_type: "executor_max_off_heap_memory_utilization",
    readable_name: "Utilized Executor Off-Heap Memory",
    description:
      "Percentage of peak memory used from the total allocated off-heap memory in the executor",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor memory",
  },
  input_records_read: {
    metric_type: "input_records_read",
    readable_name: "Input Records Read",
    description: "Total number of input records read by Spark Tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Rows",
  },
  output_records_written: {
    metric_type: "output_records_written",
    readable_name: "Output Records Written",
    description: "Total number of output records written by Spark Tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Rows",
  },
  shuffle_records_read: {
    metric_type: "shuffle_records_read",
    readable_name: "Shuffle Records Read",
    description: "Total number of shuffle records read by Spark Tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Rows",
  },
  shuffle_records_written: {
    metric_type: "shuffle_records_written",
    readable_name: "Shuffle Records Written",
    description: "Total number of shuffle records written by Spark Tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Rows",
  },
  input_bytes_read: {
    metric_type: "input_bytes_read",
    readable_name: "Input Bytes Read",
    description: "Total input bytes read by Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Bytes",
  },
  output_bytes_written: {
    metric_type: "output_bytes_written",
    readable_name: "Output Bytes Written",
    description: "Total output bytes written by Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Bytes",
  },
  shuffle_bytes_read: {
    metric_type: "shuffle_bytes_read",
    readable_name: "Shuffle Bytes Read",
    description: "Total shuffle bytes read by Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Bytes",
  },
  shuffle_bytes_written: {
    metric_type: "shuffle_bytes_written",
    readable_name: "Shuffle Bytes Written",
    description: "Total shuffle bytes written by Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "IO Bytes",
  },
  tasks_result_size_bytes: {
    metric_type: "tasks_result_size_bytes",
    readable_name: "Spark Tasks Result Size",
    description: "Total bytes transmitted back to the driver as task result",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  broadcasts_count: {
    metric_type: "broadcasts_count",
    readable_name: "Broadcasts Count",
    description: "Number of Spark Broadcasts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Broadcast counts",
  },
  broadcasts_failures: {
    metric_type: "broadcasts_failures",
    readable_name: "Broadcasts Failures",
    description: "Number of Spark Broadcasts Failures",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Broadcast counts",
  },
  broadcasts_numOutputRows: {
    metric_type: "broadcasts_numOutputRows",
    readable_name: "Broadcasts Rows",
    description: "Total number of broadcasts rows",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  broadcasts_collectTime: {
    metric_type: "broadcasts_collectTime",
    readable_name: "Broadcasts Collect Time",
    description: "Total time to collect broadcasts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "ms",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Broadcast times",
  },
  broadcasts_buildTime: {
    metric_type: "broadcasts_buildTime",
    readable_name: "Broadcasts Build Time",
    description: "Total time to build broadcasts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "ms",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Broadcast times",
  },
  broadcasts_broadcastTime: {
    metric_type: "broadcasts_broadcastTime",
    readable_name: "Broadcasts Broadcast Time",
    description: "Total time to broadcast broadcasts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "ms",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Broadcast times",
  },
  broadcasts_dataSize: {
    metric_type: "broadcasts_dataSize",
    readable_name: "Broadcasts Data Size",
    description: "Total broadcasts size",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  memory_bytes_spilled: {
    metric_type: "memory_bytes_spilled",
    readable_name: "Memory Bytes Spilled",
    description: "Total memory bytes spilled",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spill",
  },
  disk_bytes_spilled: {
    metric_type: "disk_bytes_spilled",
    readable_name: "Disk Bytes Spilled",
    description: "Total bytes spilled to disk",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spill",
  },
  skew_score: {
    metric_type: "skew_score",
    readable_name: "Skew Time",
    description: "Total skew time across all Spark stages",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Run times",
  },
  executors_vcore_time: {
    metric_type: "executors_vcore_time",
    readable_name: "Executors Allocated vCore Time",
    description: "Total Executors vCore time allocated by Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_used_vcore_time: {
    metric_type: "executors_used_vcore_time",
    readable_name: "Executors Used vCore Time",
    description: "Total Executors vCore time used by Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_run_time: {
    metric_type: "executors_run_time",
    readable_name: "Executors Run Time",
    description: "Total Executors wall time running Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  tasks_duration: {
    metric_type: "tasks_duration",
    readable_name: "Tasks Total Duration",
    description: "Total wall-clock duration summed across all Spark task attempts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_used_vcore_time_of_retried_tasks: {
    metric_type: "executors_used_vcore_time_of_retried_tasks",
    readable_name: "Retried Spark Tasks vCore Time",
    description: "Total Executors vCore time of retried Spark tasks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_used_cpu_time: {
    metric_type: "executors_used_cpu_time",
    readable_name: "Executors Used CPU Time",
    description:
      "Total CPU time the executor processes actually used (Java and Python)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_cpu_time: {
    metric_type: "executors_cpu_time",
    readable_name: "Executors Allocated CPU Time",
    description:
      "Total CPU time the machines set aside for the executors: the CPU request of each container (else its cores)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_orphaned_cpu_time: {
    metric_type: "executors_orphaned_cpu_time",
    readable_name: "Executors Orphaned CPU Time",
    description:
      "CPU time the machines held for the executors beyond their CPU requests - taken by their memory or left idle on a dedicated node",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_occupied_cpu_time: {
    metric_type: "executors_occupied_cpu_time",
    readable_name: "Executors Occupied CPU Time",
    description:
      "Total CPU time the executors took from the machines: allocated plus orphaned - what cost bills",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_machine_cpu_time: {
    metric_type: "executors_machine_cpu_time",
    readable_name: "Executors Machines CPU Time",
    description:
      "Total CPU time of the machines while they hosted the executors - on a shared cluster most of it is other workloads",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_measured_core_time: {
    metric_type: "executors_measured_core_time",
    readable_name: "Executors Measured Core Time",
    description:
      "Spark executor core time of the executors the executors_info event describes - against the agent core time it says how much of the run the event covers",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  driver_cpu_time: {
    metric_type: "driver_cpu_time",
    readable_name: "Driver Allocated CPU Time",
    description:
      "CPU time the machine set aside for the driver: the CPU request of its container (else its cores)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  driver_used_cpu_time: {
    metric_type: "driver_used_cpu_time",
    readable_name: "Driver Used CPU Time",
    description: "CPU time the driver process actually used",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_jvm_gc_time: {
    metric_type: "executors_jvm_gc_time",
    readable_name: "Executors GC Time",
    description: "Total Executors GC time in Spark tasks",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_shuffle_read_time: {
    metric_type: "executors_shuffle_read_time",
    readable_name: "Executors Shuffle-Read Time",
    description: "Total Executors Shuffle-Read time Spark tasks",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_shuffle_write_time: {
    metric_type: "executors_shuffle_write_time",
    readable_name: "Executors Shuffle-Write Time",
    description: "Total Executors Shuffle-Write time Spark tasks",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_idle_time: {
    metric_type: "executors_idle_time",
    readable_name: "Executors Idle Time",
    description: "Total time no stages were running",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Run times",
  },
  num_spark_tasks_retries: {
    metric_type: "num_spark_tasks_retries",
    readable_name: "Spark Task Retries Count",
    description: "Total number of Spark task retries",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_spark_tasks_failures: {
    metric_type: "num_spark_tasks_failures",
    readable_name: "Spark Task Failures Count",
    description: "Total number of Spark task failures",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_spark_stages_retries: {
    metric_type: "num_spark_stages_retries",
    readable_name: "Spark Stage Retries Count",
    description: "Total number of Spark stage retries",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_spark_stages_failures: {
    metric_type: "num_spark_stages_failures",
    readable_name: "Spark Stage Failures Count",
    description: "Total number of Spark stage failures",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark tasks",
  },
  num_lost_executors: {
    metric_type: "num_lost_executors",
    readable_name: "Lost Executors Count",
    description: "Total number of lost executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Spark executors",
  },
  executors_killed_oom: {
    metric_type: "executors_killed_oom",
    readable_name: "OOM-Killed Executors",
    description: "Executors removed for exceeding their memory limit",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Kills",
  },
  executors_killed_preempted: {
    metric_type: "executors_killed_preempted",
    readable_name: "Preempted Executors",
    description:
      "Executors reclaimed by the infrastructure - spot preemption / autoscaler scale-down / pod eviction - with no chance to migrate their blocks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Kills",
  },
  executors_killed_heartbeat_lost: {
    metric_type: "executors_killed_heartbeat_lost",
    readable_name: "Heartbeat-Lost Executors",
    description:
      "Executors removed after the driver stopped receiving their heartbeat",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Kills",
  },
  executors_killed_error: {
    metric_type: "executors_killed_error",
    readable_name: "Errored Executors",
    description:
      "Executors removed after a failure - non-zero exit code or a failed service registration",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Kills",
  },
  executors_killed_unknown: {
    metric_type: "executors_killed_unknown",
    readable_name: "Unknown-Reason Executors",
    description:
      "Executors removed with no reason recorded or with a reason Definity does not recognize",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Kills",
  },
  executors_killed_decommissioned: {
    metric_type: "executors_killed_decommissioned",
    readable_name: "Decommissioned Executors",
    description:
      "Executors asked to wind down gracefully - Spark ran its decommission protocol and may have migrated their blocks first",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Kills",
  },
  executors_spot: {
    metric_type: "executors_spot",
    readable_name: "Spot Executors",
    description:
      "Executors running on reclaimable capacity - AWS spot or GCE preemptible. Reported only when the agent could read the instance metadata, so an absent value means unknown, not zero",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Lifecycle",
  },
  executors_on_demand: {
    metric_type: "executors_on_demand",
    readable_name: "On-Demand Executors",
    description:
      "Executors running on reserved capacity the run keeps until it finishes - AWS on-demand/scheduled/capacity-block or GCE regular",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Lifecycle",
  },
  executors_spot_cpu_time: {
    metric_type: "executors_spot_cpu_time",
    readable_name: "Spot Executors CPU Time",
    description:
      "CPU time of the executors on reclaimable capacity - AWS spot, GCE preemptible or Azure spot. Reported only when the agent could read the instance metadata, so an absent value means unknown, not zero",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Lifecycle CPU Time",
  },
  executors_on_demand_cpu_time: {
    metric_type: "executors_on_demand_cpu_time",
    readable_name: "On-Demand Executors CPU Time",
    description:
      "CPU time of the executors on reserved capacity - AWS on-demand/scheduled/capacity-block, GCE or Azure regular",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Lifecycle CPU Time",
  },
  count_task_failures: {
    metric_type: "count_task_failures",
    readable_name: "Failed Task Count",
    description: "Number of failed tasks in the pipeline run",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  count_task_retries: {
    metric_type: "count_task_retries",
    readable_name: "Retry Task Count",
    description: "Number of task retries in the pipeline run",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  task_idle_time: {
    metric_type: "task_idle_time",
    readable_name: "Task Idle Time",
    description: "Total time no tfs were running",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Run times",
  },
  approx_lingering_vcores_time_pct: {
    metric_type: "approx_lingering_vcores_time_pct",
    readable_name: "Idle vCores Percent",
    description: "vCore time percentage of idle executors (in dynamic allocation)",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent100",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  driver_cpu_utilization: {
    metric_type: "driver_cpu_utilization",
    readable_name: "Utilized Driver CPU",
    description:
      "Percentage of peak CPU utilization from the allocated vCores in the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "Driver vCores",
  },
  driver_jvm_gc_time: {
    metric_type: "driver_jvm_gc_time",
    readable_name: "Driver GC Time",
    description: "Total Driver GC time",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Run times",
  },
  driver_jvm_gc_time_pct: {
    metric_type: "driver_jvm_gc_time_pct",
    readable_name: "Driver GC Time Percent",
    description: "GC time percentage of driver execution time",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent100",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  cached_data_max_memory_size: {
    metric_type: "cached_data_max_memory_size",
    readable_name: "Cached Data Maximum Memory Size",
    description: "The maximum value of cached data in memory",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Cache",
  },
  cached_data_max_disk_size: {
    metric_type: "cached_data_max_disk_size",
    readable_name: "Cached Data Maximum Disk Size",
    description: "The maximum value of cached data in disk",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Cache",
  },
  driver_cores: {
    metric_type: "driver_cores",
    readable_name: "Number of Driver vCores",
    description: "The number of vCores in the driver",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  executor_cores: {
    metric_type: "executor_cores",
    readable_name: "Number of Executor vCores",
    description: "The number of vCores in the executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "",
  },
  s3_list_objects_requests: {
    metric_type: "s3_list_objects_requests",
    readable_name: "S3 List Objects Requests",
    description: "Total number of S3 list objects requests",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "S3 Operations",
  },
  s3_put_object_requests: {
    metric_type: "s3_put_object_requests",
    readable_name: "S3 Put Object Requests",
    description: "Total number of S3 put object requests",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "S3 Operations",
  },
  s3_get_object_requests: {
    metric_type: "s3_get_object_requests",
    readable_name: "S3 Get Object Requests",
    description: "Total number of S3 get object requests",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "S3 Operations",
  },
  s3_head_object_requests: {
    metric_type: "s3_head_object_requests",
    readable_name: "S3 Head Object Requests",
    description: "Total number of S3 head object requests",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "S3 Operations",
  },
  fs_open_requests: {
    metric_type: "fs_open_requests",
    readable_name: "Filesystem Open Requests",
    description: "Total number of filesystem open requests",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Filesystem Operations",
  },
  fs_list_requests: {
    metric_type: "fs_list_requests",
    readable_name: "Filesystem List Requests",
    description: "Total number of filesystem list requests",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Filesystem Operations",
  },
  executors_python_used_cpu_time: {
    metric_type: "executors_python_used_cpu_time",
    readable_name: "Executors Python CPU Time",
    description: "Total Executors CPU time spent in Python code",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_java_used_cpu_time: {
    metric_type: "executors_java_used_cpu_time",
    readable_name: "Executors Java CPU Time",
    description: "Total Executors CPU time spent in Java/Scala code",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executors_other_used_cpu_time: {
    metric_type: "executors_other_used_cpu_time",
    readable_name: "Executors Other CPU Time",
    description: "Total Executors CPU time spent in other operations",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "CPU",
  },
  executor_managed_storage_memory_on_heap_max_used: {
    metric_type: "executor_managed_storage_memory_on_heap_max_used",
    readable_name: "Executor Managed Storage On-Heap Memory Watermark",
    description: "Maximum managed storage memory used on-heap across executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Managed Memory",
  },
  executor_managed_execution_memory_on_heap_max_used: {
    metric_type: "executor_managed_execution_memory_on_heap_max_used",
    readable_name: "Executor Managed Execution On-Heap Memory Watermark",
    description: "Maximum managed execution memory used on-heap across executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Managed Memory",
  },
  executor_managed_on_heap_memory_max_used: {
    metric_type: "executor_managed_on_heap_memory_max_used",
    readable_name: "Executor Managed On-Heap Memory Watermark",
    description: "Maximum total managed memory used on-heap across executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Managed Memory",
  },
  executor_managed_storage_memory_off_heap_max_used: {
    metric_type: "executor_managed_storage_memory_off_heap_max_used",
    readable_name: "Executor Managed Storage Off-Heap Memory Watermark",
    description: "Maximum managed storage memory used off-heap across executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Managed Memory",
  },
  executor_managed_off_heap_memory_max_used: {
    metric_type: "executor_managed_off_heap_memory_max_used",
    readable_name: "Executor Managed Off-Heap Memory Watermark",
    description: "Maximum total managed memory used off-heap across executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Managed Memory",
  },
  executor_managed_execution_memory_off_heap_max_used: {
    metric_type: "executor_managed_execution_memory_off_heap_max_used",
    readable_name: "Executor Managed Execution Off-Heap Memory Watermark",
    description: "Maximum managed execution memory used off-heap across executors",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "GB",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Executor Managed Memory",
  },
  batch_duration: {
    metric_type: "batch_duration",
    readable_name: "Batch Duration",
    description: "Time taken to process each micro-batch",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "ms",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming Batch Duration",
  },
  batch_count: {
    metric_type: "batch_count",
    readable_name: "Batch Count",
    description: "Number of micro-batches processed",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  trigger_count: {
    metric_type: "trigger_count",
    readable_name: "Trigger Count",
    description: "Number of streaming triggers executed",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  global_watermark_gap: {
    metric_type: "global_watermark_gap",
    readable_name: "Global Watermark Gap",
    description: "Time gap between event time watermark and processing time",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  state_total_rows: {
    metric_type: "state_total_rows",
    readable_name: "State Total Rows",
    description: "Total number of rows in the streaming state store",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming State",
  },
  state_updated_rows: {
    metric_type: "state_updated_rows",
    readable_name: "State Updated Rows",
    description: "Number of rows updated in the streaming state store per batch",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming State",
  },
  state_memory_used_bytes: {
    metric_type: "state_memory_used_bytes",
    readable_name: "State Memory Used",
    description: "Memory used by the streaming state store",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming State",
  },
  rows_dropped_by_watermark: {
    metric_type: "rows_dropped_by_watermark",
    readable_name: "Rows Dropped By Watermark",
    description: "Number of rows dropped due to watermark expiration",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  input_rows_per_sec: {
    metric_type: "input_rows_per_sec",
    readable_name: "Input Rows Per Second",
    description: "Rate of input rows received per second",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming Rows Rate",
  },
  processed_rows_per_sec: {
    metric_type: "processed_rows_per_sec",
    readable_name: "Processed Rows Per Second",
    description: "Rate of rows processed per second",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming Rows Rate",
  },
  num_input_rows: {
    metric_type: "num_input_rows",
    readable_name: "Input Rows",
    description: "Total number of input rows read in a streaming batch",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming Rows",
  },
  num_output_rows: {
    metric_type: "num_output_rows",
    readable_name: "Output Rows",
    description: "Total number of output rows written in a streaming batch",
    metric_group_type: "streaming",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Streaming Rows",
  },
  bytes_billed: {
    metric_type: "bytes_billed",
    readable_name: "Bytes Billed",
    description:
      "Bytes the warehouse billed for this query - the basis of on-demand cost",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  slot_ms: {
    metric_type: "slot_ms",
    readable_name: "Slot Time",
    description: "BigQuery slot time consumed by this query",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "ms",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "BigQuery job time",
  },
  queue_ms: {
    metric_type: "queue_ms",
    readable_name: "Queue Time",
    description:
      "Time this query waited in the warehouse queue before it started running",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "ms",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "BigQuery job time",
  },
  credits: {
    metric_type: "credits",
    readable_name: "Snowflake Credits",
    description: "Snowflake credits consumed by this query",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  num_tests_passed: {
    metric_type: "num_tests_passed",
    readable_name: "Passed Tests",
    description: "Number of dbt tests that passed in this run",
    metric_group_type: "distribution",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "dbt Tests",
  },
  num_tests_failed: {
    metric_type: "num_tests_failed",
    readable_name: "Failed Tests",
    description: "Number of dbt tests that failed in this run",
    metric_group_type: "distribution",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "dbt Tests",
  },
  num_tests_warned: {
    metric_type: "num_tests_warned",
    readable_name: "Warned Tests",
    description: "Number of dbt tests that ran and returned a warning in this run",
    metric_group_type: "distribution",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "dbt Tests",
  },
  num_tests_errored: {
    metric_type: "num_tests_errored",
    readable_name: "Errored Tests",
    description: "Number of dbt tests that could not run because of an error",
    metric_group_type: "distribution",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "dbt Tests",
  },
  num_tests_skipped: {
    metric_type: "num_tests_skipped",
    readable_name: "Skipped Tests",
    description:
      "Number of dbt tests that were skipped, usually because the model they test failed",
    metric_group_type: "distribution",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "dbt Tests",
  },
  tests_pass_ratio: {
    metric_type: "tests_pass_ratio",
    readable_name: "Tests Pass Ratio",
    description:
      "Share of the dbt tests that ran which passed - skipped tests are excluded from the denominator",
    metric_group_type: "distribution",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "",
  },
  num_tfs_failures: {
    metric_type: "num_tfs_failures",
    readable_name: "Failed TF Count",
    description: "Number of transformations that failed in the task",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "",
  },
  hosts_max_disk_used: {
    metric_type: "hosts_max_disk_used",
    readable_name: "Max Host Disk Used",
    description: "Peak disk space used on the busiest executor host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk usage",
  },
  hosts_total_disk_used_max: {
    metric_type: "hosts_total_disk_used_max",
    readable_name: "Total Host Disk Used",
    description: "Peak disk space used summed across all executor hosts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk usage",
  },
  hosts_max_disk_utilization: {
    metric_type: "hosts_max_disk_utilization",
    readable_name: "Utilized Host Disk",
    description:
      "Percentage of disk space used out of the disk capacity of the busiest executor host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk usage",
  },
  executors_max_disk_used: {
    metric_type: "executors_max_disk_used",
    readable_name: "Max Executor Disk Used",
    description: "Peak disk space used on the busiest executor host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk usage",
  },
  executors_total_disk_used_max: {
    metric_type: "executors_total_disk_used_max",
    readable_name: "Total Executors Disk Used",
    description: "Peak disk space used summed across all executor hosts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk usage",
  },
  executors_max_disk_utilization: {
    metric_type: "executors_max_disk_utilization",
    readable_name: "Utilized Executor Disk",
    description:
      "Percentage of disk space used out of the disk capacity of the busiest executor host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "percent",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk usage",
  },
  executors_total_disk_read_bytes_per_sec_max: {
    metric_type: "executors_total_disk_read_bytes_per_sec_max",
    readable_name: "Executors Disk Read Rate",
    description: "Peak disk read throughput summed across all executor hosts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk & network rates",
  },
  executors_total_disk_write_bytes_per_sec_max: {
    metric_type: "executors_total_disk_write_bytes_per_sec_max",
    readable_name: "Executors Disk Write Rate",
    description: "Peak disk write throughput summed across all executor hosts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk & network rates",
  },
  executors_total_network_read_bytes_per_sec_max: {
    metric_type: "executors_total_network_read_bytes_per_sec_max",
    readable_name: "Executors Network Read Rate",
    description: "Peak network receive throughput summed across all executor hosts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk & network rates",
  },
  executors_total_network_write_bytes_per_sec_max: {
    metric_type: "executors_total_network_write_bytes_per_sec_max",
    readable_name: "Executors Network Write Rate",
    description: "Peak network send throughput summed across all executor hosts",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Disk & network rates",
  },
  driver_disk_read_bytes_per_sec_max: {
    metric_type: "driver_disk_read_bytes_per_sec_max",
    readable_name: "Driver Disk Read Rate",
    description: "Peak disk read throughput on the driver host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver disk & network",
  },
  driver_disk_write_bytes_per_sec_max: {
    metric_type: "driver_disk_write_bytes_per_sec_max",
    readable_name: "Driver Disk Write Rate",
    description: "Peak disk write throughput on the driver host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver disk & network",
  },
  driver_network_read_bytes_per_sec_max: {
    metric_type: "driver_network_read_bytes_per_sec_max",
    readable_name: "Driver Network Read Rate",
    description: "Peak network receive throughput on the driver host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver disk & network",
  },
  driver_network_write_bytes_per_sec_max: {
    metric_type: "driver_network_write_bytes_per_sec_max",
    readable_name: "Driver Network Write Rate",
    description: "Peak network send throughput on the driver host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes/s",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Driver disk & network",
  },
  shuffle_remote_bytes_read_to_disk: {
    metric_type: "shuffle_remote_bytes_read_to_disk",
    readable_name: "Shuffle Bytes Read To Disk",
    description:
      "Remote shuffle blocks too large for memory that were fetched straight to disk",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Shuffle fetch",
  },
  scheduler_delay: {
    metric_type: "scheduler_delay",
    readable_name: "Scheduler Delay",
    description:
      "Total task time that was neither compute nor I/O - waiting to be scheduled and for results to be handled",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_deserialize_time: {
    metric_type: "executors_deserialize_time",
    readable_name: "Executors Deserialize Time",
    description:
      "Total time executors spent deserializing Spark tasks before running them",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  executors_serialize_time: {
    metric_type: "executors_serialize_time",
    readable_name: "Executors Serialize Time",
    description: "Total time executors spent serializing Spark task results",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  getting_result_time: {
    metric_type: "getting_result_time",
    readable_name: "Getting Result Time",
    description:
      "Total time the driver spent fetching Spark task results that were too large to be returned directly",
    metric_group_type: "time",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "vCore executor time",
  },
  shuffle_local_bytes_read: {
    metric_type: "shuffle_local_bytes_read",
    readable_name: "Shuffle Local Bytes Read",
    description: "Shuffle bytes read from the same executor - no network hop",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Shuffle fetch",
  },
  shuffle_remote_bytes_read: {
    metric_type: "shuffle_remote_bytes_read",
    readable_name: "Shuffle Remote Bytes Read",
    description: "Shuffle bytes fetched from other executors over the network",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Shuffle fetch",
  },
  shuffle_local_blocks_fetched: {
    metric_type: "shuffle_local_blocks_fetched",
    readable_name: "Shuffle Local Blocks Fetched",
    description: "Number of shuffle blocks read from the same executor",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Shuffle fetch",
  },
  shuffle_remote_blocks_fetched: {
    metric_type: "shuffle_remote_blocks_fetched",
    readable_name: "Shuffle Remote Blocks Fetched",
    description:
      "Number of shuffle blocks fetched from other executors over the network",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Shuffle fetch",
  },
  shuffle_remote_reqs_time: {
    metric_type: "shuffle_remote_reqs_time",
    readable_name: "Shuffle Remote Requests Time",
    description:
      "Total time spent on remote shuffle fetch requests - reported on Spark 3.4+ only",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Shuffle fetch",
  },
  shuffle_push_remote_merged_bytes_read: {
    metric_type: "shuffle_push_remote_merged_bytes_read",
    readable_name: "Push Shuffle Remote Merged Bytes Read",
    description: "Merged shuffle bytes fetched from other hosts over the network",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_local_merged_bytes_read: {
    metric_type: "shuffle_push_local_merged_bytes_read",
    readable_name: "Push Shuffle Local Merged Bytes Read",
    description: "Merged shuffle bytes read from the local host - no network hop",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "bytes",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_remote_merged_blocks_fetched: {
    metric_type: "shuffle_push_remote_merged_blocks_fetched",
    readable_name: "Push Shuffle Remote Merged Blocks Fetched",
    description:
      "Number of merged shuffle blocks fetched from other hosts over the network",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_local_merged_blocks_fetched: {
    metric_type: "shuffle_push_local_merged_blocks_fetched",
    readable_name: "Push Shuffle Local Merged Blocks Fetched",
    description: "Number of merged shuffle blocks read from the local host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_remote_merged_chunks_fetched: {
    metric_type: "shuffle_push_remote_merged_chunks_fetched",
    readable_name: "Push Shuffle Remote Merged Chunks Fetched",
    description:
      "Number of merged shuffle block chunks fetched from other hosts over the network",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_local_merged_chunks_fetched: {
    metric_type: "shuffle_push_local_merged_chunks_fetched",
    readable_name: "Push Shuffle Local Merged Chunks Fetched",
    description: "Number of merged shuffle block chunks read from the local host",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_remote_merged_reqs_time: {
    metric_type: "shuffle_push_remote_merged_reqs_time",
    readable_name: "Push Shuffle Remote Merged Requests Time",
    description: "Total time spent on remote merged shuffle fetch requests",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "seconds",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_corrupt_merged_block_chunks: {
    metric_type: "shuffle_push_corrupt_merged_block_chunks",
    readable_name: "Push Shuffle Corrupt Merged Chunks",
    description:
      "Number of corrupt merged shuffle block chunks - each one is re-fetched as its original unmerged blocks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  shuffle_push_merged_fetch_fallback_count: {
    metric_type: "shuffle_push_merged_fetch_fallback_count",
    readable_name: "Push Shuffle Fetch Fallbacks",
    description:
      "Number of times fetching a merged shuffle block failed and Spark fell back to the original unmerged blocks",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Push shuffle fetch",
  },
  broadcasts_numHashKeys: {
    metric_type: "broadcasts_numHashKeys",
    readable_name: "Broadcasts Hash Keys",
    description: "Total number of keys in the broadcast hash relations",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Broadcast counts",
  },
  broadcasts_numHashValues: {
    metric_type: "broadcasts_numHashValues",
    readable_name: "Broadcasts Hash Values",
    description: "Total number of values in the broadcast hash relations",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Broadcast counts",
  },
  "listener_bus.queue.appStatus.numDroppedEvents": {
    metric_type: "listener_bus.queue.appStatus.numDroppedEvents",
    readable_name: "Dropped Events (appStatus)",
    description:
      "Events Spark dropped from the appStatus listener queue - task and stage metrics derived from it are undercounted",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Dropped listener events",
  },
  "listener_bus.queue.eventLog.numDroppedEvents": {
    metric_type: "listener_bus.queue.eventLog.numDroppedEvents",
    readable_name: "Dropped Events (eventLog)",
    description:
      "Events Spark dropped from the eventLog listener queue - the event log for this run is incomplete",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Dropped listener events",
  },
  "listener_bus.queue.executorManagement.numDroppedEvents": {
    metric_type: "listener_bus.queue.executorManagement.numDroppedEvents",
    readable_name: "Dropped Events (executorManagement)",
    description:
      "Events Spark dropped from the executorManagement listener queue - executor add/remove tracking is incomplete",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Dropped listener events",
  },
  "listener_bus.queue.shared.numDroppedEvents": {
    metric_type: "listener_bus.queue.shared.numDroppedEvents",
    readable_name: "Dropped Events (shared)",
    description:
      "Events Spark dropped from the shared listener queue used by third-party listeners",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "integer",
    include_in_compare: false,
    live_bound: "upper_bound",
    table_grouping: "Dropped listener events",
  },
  meta_numSourceRows: {
    metric_type: "meta_numSourceRows",
    readable_name: "Source Rows",
    description: "Rows read from the source of a MERGE",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Write row counts",
  },
  meta_numUpdatedRows: {
    metric_type: "meta_numUpdatedRows",
    readable_name: "Updated Rows",
    description: "Rows updated by this write",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Write row counts",
  },
  meta_numDeletedRows: {
    metric_type: "meta_numDeletedRows",
    readable_name: "Deleted Rows",
    description: "Rows deleted by this write",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Write row counts",
  },
  meta_numCopiedRows: {
    metric_type: "meta_numCopiedRows",
    readable_name: "Copied Rows",
    description:
      "Rows rewritten unchanged while updating the files that held them - copy-on-write overhead",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Write row counts",
  },
  meta_numRowsRemoved: {
    metric_type: "meta_numRowsRemoved",
    readable_name: "Removed Rows",
    description: "Rows removed from the table by this write",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Write row counts",
  },
  meta_numTargetRowsInserted: {
    metric_type: "meta_numTargetRowsInserted",
    readable_name: "Merge Rows Inserted",
    description: "Target rows inserted by a MERGE",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsUpdated: {
    metric_type: "meta_numTargetRowsUpdated",
    readable_name: "Merge Rows Updated",
    description: "Target rows updated by a MERGE",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsDeleted: {
    metric_type: "meta_numTargetRowsDeleted",
    readable_name: "Merge Rows Deleted",
    description: "Target rows deleted by a MERGE",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: true,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsCopied: {
    metric_type: "meta_numTargetRowsCopied",
    readable_name: "Merge Rows Copied",
    description:
      "Target rows rewritten unchanged by a MERGE - copy-on-write overhead",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsRemoved: {
    metric_type: "meta_numTargetRowsRemoved",
    readable_name: "Merge Rows Removed",
    description: "Target rows removed by a MERGE",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsMatchedUpdated: {
    metric_type: "meta_numTargetRowsMatchedUpdated",
    readable_name: "Merge Rows Matched-Updated",
    description: "Target rows updated by a MERGE because they matched a source row",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsMatchedDeleted: {
    metric_type: "meta_numTargetRowsMatchedDeleted",
    readable_name: "Merge Rows Matched-Deleted",
    description: "Target rows deleted by a MERGE because they matched a source row",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsNotMatchedBySourceUpdated: {
    metric_type: "meta_numTargetRowsNotMatchedBySourceUpdated",
    readable_name: "Merge Rows Unmatched-Updated",
    description: "Target rows updated by a MERGE because no source row matched them",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  meta_numTargetRowsNotMatchedBySourceDeleted: {
    metric_type: "meta_numTargetRowsNotMatchedBySourceDeleted",
    readable_name: "Merge Rows Unmatched-Deleted",
    description: "Target rows deleted by a MERGE because no source row matched them",
    metric_group_type: "volume",
    cost_type: "metadata",
    comment: "",
    unit: "rows",
    include_in_compare: false,
    live_bound: "",
    table_grouping: "Merge row counts",
  },
  dbx_list_cost: {
    metric_type: "dbx_list_cost",
    readable_name: "Databricks List Cost",
    description:
      "What this run costs at Databricks list price - its usage priced per SKU at the list rate in force when it was used",
    metric_group_type: "resources",
    cost_type: "metadata",
    comment: "",
    unit: "currency",
    include_in_compare: true,
    live_bound: "upper_bound",
    table_grouping: "",
  },
};

export const METRIC_GROUP_TYPE_NAMES = [
  "distribution",
  "environment",
  "freshness",
  "resources",
  "schema",
  "streaming",
  "time",
  "volume",
] as const;
export type MetricGroupTypeName = (typeof METRIC_GROUP_TYPE_NAMES)[number];

// backend/app/shared_metadata/insights.csv
export interface InsightRow {
  type: string | boolean | null;
  readable_name: string | boolean | null;
  description: string | boolean | null;
  insights_group: string | boolean | null;
  grouping_metric: string | boolean | null;
}

export const INSIGHT_TYPES = [
  "over_provisioned_executors",
  "over_provisioned_cluster_machines",
  "over_provisioned_executor_heap_memory",
  "over_provisioned_executor_off_heap_memory",
  "under_provisioned_executor_heap_memory",
  "over_provisioned_driver_heap_memory",
  "over_provisioned_driver_cores",
  "over_provisioned_machine_type",
  "executors_long_gc_time",
  "executors_long_spill_time",
  "task_retries_cost",
  "long_idle_time",
  "long_skew_time",
  "small_files",
  "stuck_idle_runs",
  "stale_task_runs",
  "spark_task_retries_cost",
  "under_utilized_executors_cpu",
  "excessive_listing_operation",
  "orphaned_machine_vcores",
  "orphaned_node_resources",
  "captured_cost_savings",
  "over_provisioned_driver_machine",
  "manual_spark_job_stage_retries",
  "manual_executors_long_gc_time",
  "manual_task_retries_cost",
  "high_disk_utilization",
] as const;
export type InsightType = (typeof INSIGHT_TYPES)[number];

export const INSIGHT_METADATA: Record<InsightType, InsightRow> = {
  over_provisioned_executors: {
    type: "over_provisioned_executors",
    readable_name: "Over Provisioned Executors",
    description: "Detected long time of unused executors in execution",
    insights_group: "cost-unused",
    grouping_metric: "Executors Cores Usage",
  },
  over_provisioned_cluster_machines: {
    type: "over_provisioned_cluster_machines",
    readable_name: "Over provisioned cluster machines",
    description: "Detected long time of unused machines in execution",
    insights_group: "cost-unused",
    grouping_metric: "Executors CPU Usage",
  },
  over_provisioned_executor_heap_memory: {
    type: "over_provisioned_executor_heap_memory",
    readable_name: "On-Heap executors memory over provisioning",
    description: "Detected large unused heap memory allocation",
    insights_group: "cost-unused",
    grouping_metric: "Executor Heap Memory Breakdown",
  },
  over_provisioned_executor_off_heap_memory: {
    type: "over_provisioned_executor_off_heap_memory",
    readable_name: "Off-Heap executors memory over provisioning",
    description: "Detected large unused off-heap memory allocation",
    insights_group: "cost-unused",
    grouping_metric: "Executor Off-Heap Memory Breakdown",
  },
  under_provisioned_executor_heap_memory: {
    type: "under_provisioned_executor_heap_memory",
    readable_name: "On-Heap executors memory under provisioning",
    description: "Detected too low heap memory allocation in executors",
    insights_group: "cost-used",
    grouping_metric: "Executor Heap Memory Breakdown",
  },
  over_provisioned_driver_heap_memory: {
    type: "over_provisioned_driver_heap_memory",
    readable_name: "On-Heap driver memory over provisioning",
    description: "Detected large unused heap memory allocation in driver",
    insights_group: "cost-unused",
    grouping_metric: "Driver Memory Usage",
  },
  over_provisioned_driver_cores: {
    type: "over_provisioned_driver_cores",
    readable_name: "Over provisioned driver cores",
    description: "Detected driver allocated with more vCores than it can utilise",
    insights_group: "cost-unused",
    grouping_metric: "Driver CPU Usage",
  },
  over_provisioned_machine_type: {
    type: "over_provisioned_machine_type",
    readable_name: "Over provisioned memory",
    description: "Detected machine type with unutilized memory",
    insights_group: "cost-unused",
    grouping_metric: "Executor Memory Breakdown",
  },
  executors_long_gc_time: {
    type: "executors_long_gc_time",
    readable_name: "Long executors GC time",
    description: "Detected long vCore usage spent in executors on GC",
    insights_group: "cost-used",
    grouping_metric: "Tasks Time Breakdown",
  },
  executors_long_spill_time: {
    type: "executors_long_spill_time",
    readable_name: "High spill overhead",
    description: "Detected high spill overhead in execution time",
    insights_group: "cost-used",
    grouping_metric: "IO Bytes",
  },
  task_retries_cost: {
    type: "task_retries_cost",
    readable_name: "Task retries & failures",
    description: "Detected wasted resources of many task retries and failures",
    insights_group: "cost-used",
    grouping_metric: "",
  },
  long_idle_time: {
    type: "long_idle_time",
    readable_name: "Long execution idle time",
    description: "Detected long execution time with no executors work",
    insights_group: "health",
    grouping_metric: "Executors Cores Usage",
  },
  long_skew_time: {
    type: "long_skew_time",
    readable_name: "Long execution skew time",
    description: "Detected long skew time in executors work",
    insights_group: "health",
    grouping_metric: "Executors Cores Usage",
  },
  small_files: {
    type: "small_files",
    readable_name: "Many small files",
    description: "Detected task with many small files",
    insights_group: "health",
    grouping_metric: "",
  },
  stuck_idle_runs: {
    type: "stuck_idle_runs",
    readable_name: "Stuck idle runs",
    description:
      "Detected task runs that held their allocation for hours without doing any work",
    insights_group: "health",
    grouping_metric: "Executors Cores Usage",
  },
  stale_task_runs: {
    type: "stale_task_runs",
    readable_name: "Stale Task Runs",
    description: "Detected task runs with stale inputs",
    insights_group: "cost-used",
    grouping_metric: "",
  },
  spark_task_retries_cost: {
    type: "spark_task_retries_cost",
    readable_name: "Spark internal task retries",
    description: "Detected wasted resources of many Spark task retries",
    insights_group: "cost-used",
    grouping_metric: "",
  },
  under_utilized_executors_cpu: {
    type: "under_utilized_executors_cpu",
    readable_name: "Under utilized executors CPU time",
    description: "Detected task runs with very low CPU utilization",
    insights_group: "cost-used",
    grouping_metric: "Executors CPU Usage",
  },
  excessive_listing_operation: {
    type: "excessive_listing_operation",
    readable_name: "High number of S3 operations",
    description: "Detected task runs with very large number of S3 operations",
    insights_group: "cost-used",
    grouping_metric: "S3 Operations",
  },
  orphaned_machine_vcores: {
    type: "orphaned_machine_vcores",
    readable_name: "Orphaned CPUs (shared cluster)",
    description:
      "Detected executor memory that reserves vCores the executor never uses and leaves them unschedulable on shared machines",
    insights_group: "cost-unused",
    grouping_metric: "Executor Memory Breakdown",
  },
  orphaned_node_resources: {
    type: "orphaned_node_resources",
    readable_name: "Orphaned node resources (dedicated cluster)",
    description:
      "Detected node cores or memory left unused by stacked executors on dedicated clusters",
    insights_group: "cost-unused",
    grouping_metric: "Executors CPU Usage",
  },
  captured_cost_savings: {
    type: "captured_cost_savings",
    readable_name: "Captured Cost Savings",
    description:
      "Cost savings opportunity from reducing first and last weeks of task execution",
    insights_group: "cost-unused",
    grouping_metric: "Executors CPU Usage",
  },
  over_provisioned_driver_machine: {
    type: "over_provisioned_driver_machine",
    readable_name: "Over provisioned driver machine",
    description:
      "Detected over-provisioned driver machine type based on actual CPU and memory usage",
    insights_group: "cost-unused",
    grouping_metric: "Driver machine Usage",
  },
  manual_spark_job_stage_retries: {
    type: "manual_spark_job_stage_retries",
    readable_name: "Spark stage & task retries",
    description: "Detected wasted resources of many Spark tasks retries",
    insights_group: "cost-used",
    grouping_metric: "Executors Cores Usage",
  },
  manual_executors_long_gc_time: {
    type: "manual_executors_long_gc_time",
    readable_name: "Long executors GC time",
    description: "Detected long vCore usage spent in executors on GC",
    insights_group: "cost-used",
    grouping_metric: "Tasks Time Breakdown",
  },
  manual_task_retries_cost: {
    type: "manual_task_retries_cost",
    readable_name: "Task retries & failures",
    description: "Detected wasted resources of many task retries and failures",
    insights_group: "cost-used",
    grouping_metric: "",
  },
  high_disk_utilization: {
    type: "high_disk_utilization",
    readable_name: "High disk usage",
    description:
      "Detected task runs whose executor local disk was more than 90% full, or more than 80% full and rising",
    insights_group: "health",
    grouping_metric: "Utilized Executor Disk",
  },
};

export const INSIGHT_GROUPS = ["cost-unused", "cost-used", "health"] as const;
export type InsightGroup = (typeof INSIGHT_GROUPS)[number];

// backend/app/shared_metadata/grouping_metrics.csv
export interface ChartGroupRow {
  grouping_metric: string | boolean | null;
  table_order: string | boolean | null;
}

export const CHART_GROUPS = [
  "Executors Cores Usage",
  "Executors CPU Usage",
  "Executors Memory Usage",
  "Tasks Time Breakdown",
  "Executor Memory Breakdown",
  "Executor Heap Memory Breakdown",
  "Executor Off-Heap Memory Breakdown",
  "Driver Memory Usage",
  "Driver CPU Usage",
  "IO Bytes",
  "Cached Data",
  "Tasks",
  "S3 Operations",
  "Streaming Batch Duration",
  "Streaming Batch Count",
  "Streaming Rows",
  "Streaming Rows Rate",
  "Global Watermark Gap",
  "State Memory Used",
  "Driver GC Time",
  "Active Broadcasts Count",
  "Active Skew Time",
  "Executors Count",
] as const;
export type ChartGroupName = (typeof CHART_GROUPS)[number];

export const CHART_GROUP_METADATA: Record<ChartGroupName, ChartGroupRow> = {
  "Executors Cores Usage": {
    grouping_metric: "Executors Cores Usage",
    table_order: "0",
  },
  "Executors CPU Usage": {
    grouping_metric: "Executors CPU Usage",
    table_order: "1",
  },
  "Executors Memory Usage": {
    grouping_metric: "Executors Memory Usage",
    table_order: "2",
  },
  "Tasks Time Breakdown": {
    grouping_metric: "Tasks Time Breakdown",
    table_order: "3",
  },
  "Executor Memory Breakdown": {
    grouping_metric: "Executor Memory Breakdown",
    table_order: "4",
  },
  "Executor Heap Memory Breakdown": {
    grouping_metric: "Executor Heap Memory Breakdown",
    table_order: "5",
  },
  "Executor Off-Heap Memory Breakdown": {
    grouping_metric: "Executor Off-Heap Memory Breakdown",
    table_order: "6",
  },
  "Driver Memory Usage": {
    grouping_metric: "Driver Memory Usage",
    table_order: "8",
  },
  "Driver CPU Usage": { grouping_metric: "Driver CPU Usage", table_order: "9" },
  "IO Bytes": { grouping_metric: "IO Bytes", table_order: "10" },
  "Cached Data": { grouping_metric: "Cached Data", table_order: "12" },
  Tasks: { grouping_metric: "Tasks", table_order: "14" },
  "S3 Operations": { grouping_metric: "S3 Operations", table_order: "16" },
  "Streaming Batch Duration": {
    grouping_metric: "Streaming Batch Duration",
    table_order: "18",
  },
  "Streaming Batch Count": {
    grouping_metric: "Streaming Batch Count",
    table_order: "19",
  },
  "Streaming Rows": { grouping_metric: "Streaming Rows", table_order: "20" },
  "Streaming Rows Rate": {
    grouping_metric: "Streaming Rows Rate",
    table_order: "21",
  },
  "Global Watermark Gap": {
    grouping_metric: "Global Watermark Gap",
    table_order: "22",
  },
  "State Memory Used": { grouping_metric: "State Memory Used", table_order: "23" },
  "Driver GC Time": { grouping_metric: "Driver GC Time", table_order: "20" },
  "Active Broadcasts Count": {
    grouping_metric: "Active Broadcasts Count",
    table_order: "20",
  },
  "Active Skew Time": { grouping_metric: "Active Skew Time", table_order: "20" },
  "Executors Count": { grouping_metric: "Executors Count", table_order: "20" },
};

// backend/app/shared_metadata/timeseries_metric_types.csv
export interface ChartLineRow {
  grouping_metric: string | boolean | null;
  time_series_metric_type: string | boolean | null;
  is_pattern: string | boolean | null;
  units: string | boolean | null;
  metrics_conf_type: string | boolean | null;
  line_name: string | boolean | null;
  priority: string | boolean | null;
}

export const CHART_LINES: readonly ChartLineRow[] = [
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "machine_cpus_over_time",
    is_pattern: "",
    units: "CPU",
    metrics_conf_type: "executors_machine_cpu_time",
    line_name: "Machine-CPUs",
    priority: "0",
  },
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "executors_cpus_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "executors_cpu_time",
    line_name: "Executor-CPUs",
    priority: "1",
  },
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "orphaned_vcores_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "executors_orphaned_cpu_time",
    line_name: "Orphaned-CPUs",
    priority: "0",
  },
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "executors_used_cpu_time_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "executors_used_cpu_time",
    line_name: "Used-CPUs",
    priority: "2",
  },
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "executors_java_used_cpu_time_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "executors_java_used_cpu_time",
    line_name: "Java-CPUs",
    priority: "3",
  },
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "executors_python_used_cpu_time_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "executors_python_used_cpu_time",
    line_name: "Python-CPUs",
    priority: "3",
  },
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "executors_other_used_cpu_time_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "executors_other_used_cpu_time",
    line_name: "Other-CPUs",
    priority: "3",
  },
  {
    grouping_metric: "Executors CPU Usage",
    time_series_metric_type: "vcores_max_over_time",
    is_pattern: "",
    units: "CPU",
    metrics_conf_type: "vcore_time",
    line_name: "Executor-Cores-Fallback",
    priority: "1",
  },
  {
    grouping_metric: "Executors Cores Usage",
    time_series_metric_type: "vcores_max_over_time",
    is_pattern: "",
    units: "Core",
    metrics_conf_type: "vcore_time",
    line_name: "Allocated-Cores",
    priority: "1",
  },
  {
    grouping_metric: "Executors Cores Usage",
    time_series_metric_type: "vcores_max_used_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "used_vcore_time",
    line_name: "Max-Used-By-Task",
    priority: "2",
  },
  {
    grouping_metric: "Executors Cores Usage",
    time_series_metric_type: "vcores_avg_used_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "used_vcore_time",
    line_name: "Avg-Used-By-Task",
    priority: "2",
  },
  {
    grouping_metric: "Executors Cores Usage",
    time_series_metric_type: "app_vcores_max_used_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "",
    line_name: "Used-By-All-Tasks",
    priority: "0",
  },
  {
    grouping_metric: "Executors Cores Usage",
    time_series_metric_type: "avg_lingering_vcores_due_to_cache_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "approx_lingering_vcores_time_pct",
    line_name: "Cache-Idle-Cores",
    priority: "3",
  },
  {
    grouping_metric: "Executors Cores Usage",
    time_series_metric_type: "avg_lingering_vcores_due_to_shuffle_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "",
    line_name: "Shuffle-Idle-Cores",
    priority: "3",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "tasks_duration_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "tasks_duration",
    line_name: "Tasks-Duration",
    priority: "1",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "executors_run_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "executors_run_time",
    line_name: "Run-Time",
    priority: "2",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "executors_used_vcore_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "",
    line_name: "Run-Time-Fallback",
    priority: "2",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "executors_jvm_gc_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "executors_jvm_gc_time",
    line_name: "GC-Time",
    priority: "2",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "executors_shuffle_write_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "executors_shuffle_write_time",
    line_name: "Shuffle-Write-Time",
    priority: "2",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "executors_shuffle_read_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "executors_shuffle_read_time",
    line_name: "Shuffle-Read-Time",
    priority: "2",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "executors_deserialize_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "executors_deserialize_time",
    line_name: "Deserialize-Time",
    priority: "3",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "executors_serialize_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "executors_serialize_time",
    line_name: "Serialize-Time",
    priority: "3",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "scheduler_delay_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "scheduler_delay",
    line_name: "Scheduler-Delay",
    priority: "3",
  },
  {
    grouping_metric: "Tasks Time Breakdown",
    time_series_metric_type: "getting_result_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "getting_result_time",
    line_name: "Getting-Result-Time",
    priority: "3",
  },
  {
    grouping_metric: "Executors Memory Usage",
    time_series_metric_type: "executor_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_memory",
    line_name: "Allocated",
    priority: "1",
  },
  {
    grouping_metric: "Executors Memory Usage",
    time_series_metric_type: "executor_avg_used_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "",
    line_name: "Used Memory",
    priority: "2",
  },
  {
    grouping_metric: "Executor Memory Breakdown",
    time_series_metric_type: "executor_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_memory",
    line_name: "Allocated",
    priority: "1",
  },
  {
    grouping_metric: "Executor Memory Breakdown",
    time_series_metric_type: "executor_max_used_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_max_used_memory",
    line_name: "Max-Used-Memory",
    priority: "2",
  },
  {
    grouping_metric: "Executor Memory Breakdown",
    time_series_metric_type: "executor_avg_used_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "",
    line_name: "Avg-Used-Memory",
    priority: "2",
  },
  {
    grouping_metric: "Executor Memory Breakdown",
    time_series_metric_type: "executor_heap_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_heap_memory",
    line_name: "Allocated-Heap",
    priority: "0",
  },
  {
    grouping_metric: "Executor Memory Breakdown",
    time_series_metric_type: "executor_max_used_heap_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_max_used_heap_memory",
    line_name: "Max-Used-Heap-Memory",
    priority: "0",
  },
  {
    grouping_metric: "Executor Heap Memory Breakdown",
    time_series_metric_type: "executor_heap_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_heap_memory",
    line_name: "Allocated Heap",
    priority: "1",
  },
  {
    grouping_metric: "Executor Heap Memory Breakdown",
    time_series_metric_type: "executor_max_used_heap_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_max_used_heap_memory",
    line_name: "Max-Used-Heap-Memory",
    priority: "2",
  },
  {
    grouping_metric: "Executor Heap Memory Breakdown",
    time_series_metric_type:
      "executor_managed_storage_memory_on_heap_max_used_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "executor_managed_storage_memory_on_heap_max_used",
    line_name: "Used-Storage-Memory",
    priority: "0",
  },
  {
    grouping_metric: "Executor Heap Memory Breakdown",
    time_series_metric_type:
      "executor_managed_execution_memory_on_heap_max_used_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "executor_managed_execution_memory_on_heap_max_used",
    line_name: "Used-Execution-Memory",
    priority: "0",
  },
  {
    grouping_metric: "Executor Off-Heap Memory Breakdown",
    time_series_metric_type: "executor_max_used_off_heap_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "executor_max_off_heap_used_memory",
    line_name: "Max-Used Off-Heap",
    priority: "2",
  },
  {
    grouping_metric: "Executor Off-Heap Memory Breakdown",
    time_series_metric_type:
      "executor_managed_storage_memory_off_heap_max_used_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "executor_managed_storage_memory_off_heap_max_used",
    line_name: "Used-Storage-Memory",
    priority: "0",
  },
  {
    grouping_metric: "Executor Off-Heap Memory Breakdown",
    time_series_metric_type:
      "executor_managed_execution_memory_off_heap_max_used_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "executor_managed_execution_memory_off_heap_max_used",
    line_name: "Used-Execution-Memory",
    priority: "0",
  },
  {
    grouping_metric: "Driver Memory Usage",
    time_series_metric_type: "driver_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "driver_memory",
    line_name: "Allocated",
    priority: "1",
  },
  {
    grouping_metric: "Driver Memory Usage",
    time_series_metric_type: "driver_used_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "",
    line_name: "Used",
    priority: "2",
  },
  {
    grouping_metric: "Driver Memory Usage",
    time_series_metric_type: "driver_heap_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "driver_heap_memory",
    line_name: "Allocated-Heap",
    priority: "0",
  },
  {
    grouping_metric: "Driver Memory Usage",
    time_series_metric_type: "driver_used_heap_memory_over_time",
    is_pattern: "",
    units: "GB",
    metrics_conf_type: "",
    line_name: "Used-Heap",
    priority: "0",
  },
  {
    grouping_metric: "Driver CPU Usage",
    time_series_metric_type: "driver_jvm_gc_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "driver_jvm_gc_time",
    line_name: "GC-Time",
    priority: "1",
  },
  {
    grouping_metric: "Driver CPU Usage",
    time_series_metric_type: "driver_used_cpu_time_over_time",
    is_pattern: "",
    units: "ms",
    metrics_conf_type: "driver_used_cpu_time",
    line_name: "Used-CPUs",
    priority: "2",
  },
  {
    grouping_metric: "IO Bytes",
    time_series_metric_type: "input_bytes_read_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "input_bytes_read",
    line_name: "Input-Bytes-Read",
    priority: "2",
  },
  {
    grouping_metric: "IO Bytes",
    time_series_metric_type: "output_bytes_written_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "output_bytes_written",
    line_name: "Output-Bytes-Written",
    priority: "2",
  },
  {
    grouping_metric: "IO Bytes",
    time_series_metric_type: "shuffle_bytes_read_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "shuffle_bytes_read",
    line_name: "Shuffle-Bytes-Read",
    priority: "3",
  },
  {
    grouping_metric: "IO Bytes",
    time_series_metric_type: "shuffle_bytes_written_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "shuffle_bytes_written",
    line_name: "Shuffle-Bytes-Written",
    priority: "3",
  },
  {
    grouping_metric: "IO Bytes",
    time_series_metric_type: "disk_bytes_spilled_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "disk_bytes_spilled",
    line_name: "Disk-Bytes-Spilled",
    priority: "1",
  },
  {
    grouping_metric: "Cached Data",
    time_series_metric_type: "cached_data_memory_size_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "cached_data_max_memory_size",
    line_name: "Memory-Size",
    priority: "2",
  },
  {
    grouping_metric: "Cached Data",
    time_series_metric_type: "cached_data_disk_size_over_time",
    is_pattern: "",
    units: "Bytes",
    metrics_conf_type: "cached_data_max_disk_size",
    line_name: "Disk-Size",
    priority: "3",
  },
  {
    grouping_metric: "Tasks",
    time_series_metric_type: "stages_retries_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "num_spark_stages_retries",
    line_name: "Stage-Retries",
    priority: "2",
  },
  {
    grouping_metric: "Tasks",
    time_series_metric_type: "stages_failures_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "num_spark_stages_failures",
    line_name: "Stage-Failures",
    priority: "2",
  },
  {
    grouping_metric: "Tasks",
    time_series_metric_type: "active_tasks_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "num_spark_tasks",
    line_name: "Active-Tasks",
    priority: "3",
  },
  {
    grouping_metric: "Tasks",
    time_series_metric_type: "tasks_retries_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "num_spark_tasks_retries",
    line_name: "Task-Retries",
    priority: "3",
  },
  {
    grouping_metric: "Tasks",
    time_series_metric_type: "tasks_failures_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "num_spark_tasks_failures",
    line_name: "Task-Failures",
    priority: "3",
  },
  {
    grouping_metric: "S3 Operations",
    time_series_metric_type: "s3_list_objects_requests_over_time",
    is_pattern: "",
    units: "file-listing",
    metrics_conf_type: "s3_list_objects_requests",
    line_name: "S3-Listings",
    priority: "2",
  },
  {
    grouping_metric: "S3 Operations",
    time_series_metric_type: "s3_requests_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "s3_get_object_requests",
    line_name: "S3-Requests",
    priority: "3",
  },
  {
    grouping_metric: "Streaming Batch Duration",
    time_series_metric_type: "^(batch_operation_duration[.].*|batch_duration)$",
    is_pattern: "true",
    units: "ms",
    metrics_conf_type: "",
    line_name: "",
    priority: "2",
  },
  {
    grouping_metric: "Streaming Batch Count",
    time_series_metric_type: "batch_count",
    is_pattern: "false",
    units: "",
    metrics_conf_type: "",
    line_name: "",
    priority: "2",
  },
  {
    grouping_metric: "Streaming Batch Count",
    time_series_metric_type: "trigger_count",
    is_pattern: "false",
    units: "",
    metrics_conf_type: "",
    line_name: "",
    priority: "2",
  },
  {
    grouping_metric: "Streaming Rows",
    time_series_metric_type:
      "^(num_output_rows[.].+|state_total_rows|state_updated_rows|rows_dropped_by_watermark|num_input_rows[.].+)$",
    is_pattern: "true",
    units: "",
    metrics_conf_type: "",
    line_name: "",
    priority: "2",
  },
  {
    grouping_metric: "Streaming Rows Rate",
    time_series_metric_type: "^(input_rows_per_sec|processed_rows_per_sec)$",
    is_pattern: "true",
    units: "1/s",
    metrics_conf_type: "",
    line_name: "",
    priority: "2",
  },
  {
    grouping_metric: "Global Watermark Gap",
    time_series_metric_type: "global_watermark_gap",
    is_pattern: "false",
    units: "seconds",
    metrics_conf_type: "",
    line_name: "",
    priority: "2",
  },
  {
    grouping_metric: "State Memory Used",
    time_series_metric_type: "state_memory_used_bytes",
    is_pattern: "false",
    units: "Bytes",
    metrics_conf_type: "",
    line_name: "",
    priority: "2",
  },
  {
    grouping_metric: "Active Broadcasts Count",
    time_series_metric_type: "active_broadcasts_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "broadcasts_count",
    line_name: "Count",
    priority: "1",
  },
  {
    grouping_metric: "Active Skew Time",
    time_series_metric_type: "skew_score_over_time",
    is_pattern: "",
    units: "seconds",
    metrics_conf_type: "skew_score",
    line_name: "Active-Skew-Time",
    priority: "1",
  },
  {
    grouping_metric: "Executors Count",
    time_series_metric_type: "lost_executors_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "num_lost_executors",
    line_name: "Lost-Executors",
    priority: "0",
  },
  {
    grouping_metric: "Executors Count",
    time_series_metric_type: "used_executors_over_time",
    is_pattern: "",
    units: "",
    metrics_conf_type: "",
    line_name: "Used-Executors",
    priority: "0",
  },
];

// backend/app/shared_metadata/metric_types_profiles.json
export const METRIC_TYPE_PROFILES = [
  "complexColumn",
  "lowCardinalityColumn",
  "timeColumn",
  "stringColumn",
  "numberColumn",
  "table",
] as const;
export type MetricTypeProfiles = (typeof METRIC_TYPE_PROFILES)[number];

export const METRIC_TYPE_PROFILE_MEMBERS: Record<
  MetricTypeProfiles,
  readonly MetricTypeName[]
> = {
  complexColumn: ["cnt", "null_pct"],
  lowCardinalityColumn: [
    "cnt_distinct",
    "pct_distinct",
    "pct_unique",
    "cnt",
    "null_pct",
    "cnt_values",
  ],
  timeColumn: [
    "cnt_distinct",
    "pct_distinct",
    "pct_unique",
    "max_time_delta",
    "live_max_time_delta",
    "cnt",
    "null_pct",
  ],
  stringColumn: ["cnt_distinct", "pct_distinct", "pct_unique", "cnt", "null_pct"],
  numberColumn: [
    "cnt_distinct",
    "pct_distinct",
    "pct_unique",
    "min",
    "max",
    "avg",
    "stddev",
    "nan_cnt",
    "cnt",
    "null_pct",
  ],
  table: ["cnt"],
};

/** Every file in backend/app/shared_metadata, as of the last generation. Asserted against the folder in tests. */
export const GENERATED_SOURCES = [
  "backend/app/shared_metadata/grouping_metrics.csv",
  "backend/app/shared_metadata/insights.csv",
  "backend/app/shared_metadata/metric_types.csv",
  "backend/app/shared_metadata/metric_types_profiles.json",
  "backend/app/shared_metadata/timeseries_metric_types.csv",
] as const;
